<template>

  
        <DBox
            :id="'cmp-catalog-statement-sidewindow-send_log'"
            :addButton="false"
            :addLink="false"
            :addLinkLabel="`${$t('add_new')} ${$t('genre')}`"
            :rightMenu="[
                    {
                        text: 'Empty Log',
                        value: 'Empty Log',
                    },
               
            ]"
             @menuClick="onRightMenuClick"

         
        >
          <template  v-if="log.length>0">
            <div 
             :class="{ 'bbb':log.length>0?true:false}"
             >
              <p v-for="(item,index) in log" :key="index">{{item}}</p>
            </div>
          </template>
        </DBox>
  
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
// import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
// import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {

    selectedStatementDetails: {
        type: Object,
    },
  },
  components: {
        NTable,
        DBox
   
  },
  data: function() {
    return {
   
  
    };
  },
  computed:{

        log:function(){
         
            return this.selectedStatementDetails?.response?.rp?.send_log?.split("\n")||[]
            
        },

      
      
  

  },
  methods:{
    onRightMenuClick: function(menu) {
     this.$emit("emptyLog")

    }
  }

}
</script>
<style lang="scss">
.cmp-catalog-statement-sidewindow-send_log{
  
  
    div.bbb{
      border-bottom:1px solid var(--sprt-85) ;
    }
  
  
  p{
      padding:10px 10px 0px 10px;
      margin-bottom: 0px;
  }

}
</style>
